<template>
  <div
    class="v-navbar-menu-mobile">
    <div class="v-nav-left">
      <div
        class="navbar-item"
        @click="$emit('close')"
      ><metis-logo/></div>
      <router-link
        class="navbar-item"
        @click.native="$emit('close')"

        exact
        to="/">Accueil</router-link>
      <router-link
        v-for="(route, index) in leftRoutes"
        :key="index"
        class="navbar-item"
        @click.native="$emit('close')"

        exact
        :to="route.path">{{ route.leftNavTitle }}</router-link></div>
    <div class="v-nav-right">
      <router-link
        v-if="!me"
        v-for="(route, index) in rightRoutes"
        @click.native="$emit('close')"

        :key="index"
        class="navbar-item"
        exact
        :to="route.path">{{ route.rightNavTitle }}</router-link>
      <router-link
        v-if="me"
        @click.native="$emit('close')"
        class="navbar-item"
        exact
        to="#">Hello {{ me.firstName }} !</router-link>

    </div>
  </div>
</template>
<script>
import MetisLogo from "../ui/metis-logo.vue";

export default {
  name: "NavMenuMobile",
  components: { MetisLogo },
  props: {
    leftRoutes: Array,
    me: Object,
    logout: Function,
    rightRoutes: Array
  }
};
</script>
<style scoped lang="scss">
.fas:hover {
  cursor: pointer;
}

.v-navbar-menu-mobile {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  /* right: 50vw; */
  display: flex;
  width: 200px;
  flex-direction: column;
  background: white;
  justify-content: inherit;
  z-index: 200;
}
.v-nav-right,
.v-nav-left {
  display: flex;
  flex-direction: column;
}
.navbar-item {
  display: flex;
  align-items: center;
}

@media screen and (min-width: 700px) {
  .v-navbar-menu-mobile {
    display: none;
  }
}
</style>
